import produce from 'immer';

import { wrapReducers } from '~/state/lib';
import INIT_STATE from './state';

const targetingReducer = {
  addCity: (state, city) => produce(state, (draft) => {
    draft.cities.push({
      ...city,
      radius: '15',
      distance_unit: 'mile',
    });
  }),
  removeCity: (state, key) => produce(state, (draft) => {
    draft.cities = draft.cities.filter(el => el.key !== key);
  }),
  updateCity: (state, city) => produce(state, (draft) => {
    draft.cities = draft.cities.map(el => (el.key === city.key ? city : el));
  }),
  clearCities: state => produce(state, (draft) => {
    draft.cities = [];
  }),
  addInterest: (state, { id, name }) => produce(state, (draft) => {
    draft.interests.push({ id, name });
  }),
  removeInterest: (state, key) => produce(state, (draft) => {
    draft.interests = draft.interests.filter(el => el.id !== key);
  }),
  clearInterests: state => produce(state, (draft) => {
    draft.interests = [];
  }),
  addCustomAudience: (state, { id }) => produce(state, (draft) => {
    draft.customAudiences.push(id);
  }),
  removeCustomAudience: (state, key) => produce(state, (draft) => {
    draft.customAudiences = draft.customAudiences.filter(el => el !== key);
  }),
  clearCustomAudiences: state => produce(state, (draft) => {
    draft.customAudiences = [];
  }),
  targetingReady: state => produce(state, (draft) => {
    draft.ready = true;
  }),
};

export default wrapReducers(targetingReducer, INIT_STATE);
